import React, { useState } from 'react';
import { StyleSheet, Text, View, Image, Button, TouchableOpacity, TouchableWithoutFeedback, Switch} from 'react-native';
import SoundDivider from '../SoundDivider';



const MinionFilters = (props) => {
  const visibility = props.visibility
  const filterCards = props.filterCards
  const [nonCollectible, setNonCollectible] = props.cardFiltersHook['nonCollectible']
  const [types, setTypes] = props.cardFiltersHook['types']
  const [rarityFilters, setRarityFilters] = props.cardFiltersHook['rarity']

  const cardFilterDict = {
    'nonCollectible': nonCollectible,
    'types': types,
    'rarity': rarityFilters
  }

  const styles = StyleSheet.create({
    filterMenu:
      {position: 'absolute', right:48, top:56, zIndex: 1, backgroundColor: 'white', visibility: visibility,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5
    }
  })

  const TypeFilter = (props) => {
    var type = props.type
    var mappedType = mapTypes(type)

    function mapTypes(type) {
    switch(type) {
        case 'Minions': return 'MINION'
        case 'Heroes': return 'HERO'
        case 'Spells': return 'SPELL'
        case 'Weapons': return 'WEAPON'
        case 'Locations': return 'LOCATION'
      }
    }

    return (
      <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 16}}>
        <Text style={{paddingRight: 16}}>{type}</Text>
        <Switch onValueChange={() => {
            var newTypeFilter = types
            newTypeFilter[mappedType] = !newTypeFilter[mappedType]
            cardFilterDict['types'] = newTypeFilter
            setTypes(newTypeFilter)
            filterCards(null, true, false, cardFilterDict)
          }} value={types[mappedType]} />
      </View>
    )
  }

  const RarityFilter = (props) => {
    var rarity = props.rarity
    return (
      <TouchableOpacity onPress={ () => {
        var newRarityFilter = rarityFilters
        newRarityFilter[rarity] = !newRarityFilter[rarity]
        cardFilterDict['rarity'] = newRarityFilter
        setRarityFilters(newRarityFilter)
        filterCards(null, true, false, cardFilterDict)
      }}>
        <Image style={{width: 34, height: 44}} source={require('../assets/img/'+rarity.toLowerCase()+'_gem_small.png')}/>
        <Image style={{width: 34, height: 44, marginTop: -44, visibility: ((rarityFilters[rarity] || visibility == 'hidden') ? 'hidden' : 'visible')}} source={require('../assets/img/exclude.png')}/>
      </TouchableOpacity>
    )
  }

  return (
    <View style={styles.filterMenu}>
      <View style={{paddingBottom: 16, paddingHorizontal: 16}}>
        {['Minions', 'Heroes', 'Spells', 'Weapons', 'Locations'].map(type => <TypeFilter type={type} />)}
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 16, paddingBottom: 16}}>
          <Text style={{paddingRight: 16}}>Non-Collectible</Text>
          <Switch onValueChange={(newNonCollectibleFilter) => {
            cardFilterDict['nonCollectible'] = newNonCollectibleFilter
            setNonCollectible(newNonCollectibleFilter)
            filterCards(null, true, false, cardFilterDict)
          }} value={nonCollectible} />
        </View>
        <SoundDivider />
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8}}>
          {['COMMON', 'RARE', 'EPIC', 'LEGENDARY'].map(rarity => <RarityFilter rarity={rarity} />)}
        </View>
      </View>
    </View>
  )


}

export default MinionFilters
